<template>
  <div class="ml-dropdown" ref="ml-dropdown">
    <div
      class="ml-dropdown-toggle"
      @click="toggleDropdown"
      :class="{ active: isNonDefaultSelected }"
    >
      {{ selectedLabel }}
       <span class="ml-svg-icon text-primary" style="cursor: pointer">
        <inline-svg :src="'/assets/svg/chevron-down.svg'" />
      </span>
    </div>

    <div v-if="isOpen" class="ml-dropdown-menu">
      <div
        v-for="(p, i) in periods"
        :key="`period-${i}`"
        @click="selectPeriod(p)"
        :class="['ml-dropdown-item', { selected: p.id === currentPeriodId }]"
      >
        {{ p.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setCurrentPeriodId, getCurrentPeriod } from '@/core/services/companyAccess';

export default {
  name: 'PeriodsDropdown',
  data() {
    return {
      isOpen: false,
      initialized: false,
    };
  },
  computed: {
    ...mapGetters(['periods', 'currentPeriodId']),
    selectedLabel() {
      const selected = this.periods.find(p => p.id === this.currentPeriodId);
      return selected ? selected.name : 'Välj period';
    },
    isNonDefaultSelected() {
      return this.periods.length && this.currentPeriodId !== this.periods[0].id;
    }
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    async selectPeriod(period) {
      this.isOpen = false;
      await setCurrentPeriodId(period.id, this.initialized);
    },
    onClickOutside(event) {
      const dropdown = this.$refs['ml-dropdown'];
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style scoped>
.ml-dropdown {
  position: relative;
  width: 100%;
  max-width: 275px;
}


.ml-dropdown-toggle:hover {
  background-color: #1bc5bd;
  color: white;
}
.menu-icon {
  color: #1bc5bd;
}
.ml-dropdown-toggle {
  padding: 12px 16px;
  border: 1px solid #1bc5bd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.5;
  height: 36px;
  width: 100px;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis for overflowing text */
  color: #1bc5bd;
}


.ml-dropdown-toggle.active {
  border-color: #1bc5bd;
  color: #1bc5bd;
}

.ml-svg-icon {
  font-size: 1rem; /* Adjust size as needed */
  margin-left: 14px;
}
.ml-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  border: 1px solid #ccc;
  background: white;
  border-radius: 4px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.ml-dropdown-item {
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.ml-dropdown-item:hover {
  background-color: #f5f5f5;
}

.ml-dropdown-item.selected {
  background-color: #1bc5bd;
  color: white;
}
</style>
